@use "ui/styles/colorsOld";

.charLimitWrapper {
  position: relative;
}

.charLimitLabel {
  font-size: 12px;
  float: right;
  display: block;
  margin-top: 5px;
  width: 36px;
}
